export default __webpack_public_path__ + "static/media/red-ring.f407b342.png";